module.exports = function() {
  return new Worker(__webpack_public_path__ + "0ac1f87d40b93fb635d1.worker.js");
};